import type { GPGameTeamResponse } from "../../../types";

export function formatTeamSheetTeamLabel(team: GPGameTeamResponse | null): string {
	if (!team) {
		return "-";
	}
	const category = team.team?.category?.trim();
	const c = team.clubName?.trim();
	const t = team.teamName?.trim();
	if (c || t) {
		return [c, category, t].filter(Boolean).join(" ");
	}
	return [team.club?.name?.trim(), category, team.team?.name?.trim()].filter(Boolean).join(" ");
}

export function formatLastTimeGradedDisplay(iso: string): string {
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) {
		return "";
	}
	const pad = (n: number) => String(n).padStart(2, "0");
	return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
